/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  ICreateTransactionMethods,
  CreateTransactionService
} from "./components";

export type APV2PaymentDetailsPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ICreateTransactionMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new StaticPageContentService(),
    new LoadingService(),
    new CreateTransactionService()
  ];
};

export const getAgent = () => {
  return createAgent<APV2PaymentDetailsPageAgent>({
    plugins: getPlugins(),
  });
};
